import { RequestOptions } from './request-options';

export class RecipeComponentRequest extends RequestOptions {
    Id_Compaund: number;
    Id_Recipe: number;
    RecipeFullName: string;
    Id_Product: number;
    ProductFullName: string;
    Id_ParentRecipe: number;
    Density: number;
    IsBulk: number;
    Id_ProductCluster: number;
    ProductClusterFullName: string;
    Id_ProductClusterPersonal: number;
    WeightPercentage: number;
    CalorificIndex: number;
    UIndex: number;
    CalculationWeight: number;
    IsChangeable: number;
    RecalcName: string;
    RecalcVolume: number;
    StateForChange: number;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/recipe-component-request.ts